export const removeFalsyKeys = <T extends object>(obj: T) =>
  Object.fromEntries(Array.from(Object.entries(obj)).filter(([, value]) => !!value));
